module.exports = __webpack_public_path__ + "static/hill2-6166a2775e1eb4002608c0411dae3963.svg";